import { breakpoints, pxToRem, scrollbar, themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
import { LAYOUT_SIDEBAR_CSS_VARIABLE_WIDTH, LAYOUT_SIDEBAR_CSS_VARIABLE_WIDTH_TRANSITION, SIDEBAR_WIDTH_TRANSITION_DURATION_MS, } from './useScreenSidebar';
const barStyles = css `
  flex-shrink: 0;
  display: flex;
  align-items: center;
  min-height: ${pxToRem(43)}; // One extra pixel to account for the border
  padding: 0 ${themeGet('spacing.xl')};
  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
export const Section = styled.section `
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;

  background-color: ${themeGetColor('background.50')};

  ${breakpoints.desktop} {
    margin: ${themeGet('spacing.md')};
    margin-left: 0;

    border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
    border-radius: ${themeGet('borderRadius.md')};
  }
`;
export const TopbarContainer = styled.header `
  ${barStyles};
  gap: ${themeGet('spacing.md')};
`;
export const TopbarDivider = styled.div `
  width: ${pxToRem(1)};
  height: ${pxToRem(14)};
  background-color: ${themeGet('colors.border.100')};

  ${(props) => props.$side === 'left' ? `margin-right: ${themeGet('spacing.sm')}` : `margin-left: ${themeGet('spacing.sm')}`};
`;
export const ContentBarContainer = styled.div `
  ${barStyles};
`;
export const Main = styled.div `
  display: flex;
  position: relative;
  height: 100%;
  overflow: hidden;
`;
export const ContentContainer = styled.main `
  display: flex;
  flex-direction: column;
  flex: 1 auto;
  width: 100%;

  padding: ${themeGet('spacing.lg')} ${themeGet('spacing.xl')};

  overflow: auto;
  ${scrollbar({ trackMargin: 'sm' })};

  width: calc(100% - var(${LAYOUT_SIDEBAR_CSS_VARIABLE_WIDTH}));
`;
export const SidebarInnerContainer = styled.div `
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;

  overflow: hidden auto;

  border-left: solid ${pxToRem(1)} ${themeGet('colors.border.100')};

  transition: transform ${SIDEBAR_WIDTH_TRANSITION_DURATION_MS}ms ease-in-out;

  ${scrollbar({ trackMargin: 'sm' })};

  ${breakpoints.desktop} {
    width: var(${LAYOUT_SIDEBAR_CSS_VARIABLE_WIDTH});
    transition: var(${LAYOUT_SIDEBAR_CSS_VARIABLE_WIDTH_TRANSITION});
  }
`;
export const SidebarContainer = styled.aside `
  position: absolute;
  z-index: 1;
  width: 100dvw;
  height: 100%;

  top: 0;
  left: 0;
  background-color: ${themeGet('colors.background.50')};

  transition: transform 0.2s ease-in-out;

  transform: translateX(${(p) => (p.$open ? '0' : '100%')});

  overflow: ${(props) => !props.$open && 'hidden'};

  ${breakpoints.desktop} {
    width: var(${LAYOUT_SIDEBAR_CSS_VARIABLE_WIDTH});
    position: sticky;
    transform: unset;
    z-index: unset;

    ${(props) => props.$isDragging
    ? 'transition: unset;'
    : `transition: width ${SIDEBAR_WIDTH_TRANSITION_DURATION_MS}ms ease-in-out;`};

    ${(props) => !props.$open && 'width: 0;'}
  }
`;
export const SidebarDraggableLine = styled.div `
  position: relative;
  height: 100%;
  width: ${pxToRem(3)};
  margin-left: -${pxToRem(1)};
  background-color: transparent;
  transition: background-color 175ms ease-in-out;
`;
export const SidebarDraggableHover = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: -${pxToRem(8)};
  padding: 0 ${pxToRem(8)};
  margin-left: -${pxToRem(1)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: col-resize;

  &:hover {
    ${SidebarDraggableLine} {
      background-color: ${themeGet('colors.gray.500')};
    }
  }

  ${(p) => p.$isDragging &&
    `
    ${SidebarDraggableLine} {
      background-color: ${themeGet('colors.gray.500')};
    }
  `}
`;
